import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlayCircle,
  faPauseCircle,
  faStopCircle,
  faSearch,
  faPlusCircle,
  faPlay,
  faStepBackward,
  faStepForward,
  faRandom,
  faUndoAlt,
  faPause,
  faMinusCircle,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp, faTelegram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faPlayCircle,
  faPauseCircle,
  faStopCircle,
  faSearch,
  faPlusCircle,
  faMinusCircle,
  faPlay,
  faPause,
  faStepBackward,
  faStepForward,
  faRandom,
  faUndoAlt,
  faCopy,
  faWhatsapp,
  faTelegram
);

createApp(App)
  .use(router)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");

/* Vue.config.productionTip = false */
